// Todo: removing "any" type casting
const createIntlOptions = ({ selectedChannel, options }) => {
    const numberFormats = {};
    selectedChannel.currencies &&
        selectedChannel.currencies.forEach(currency => {
            if (!currency || !currency.format || !currency.id)
                return null;
            numberFormats[currency.id] = {
                style: 'currency',
                currency: currency.format.code,
                minimumFractionDigits: currency.format.decimals
            };
        });
    return Object.assign({ formats: {
            number: numberFormats
        } }, options);
};
export default createIntlOptions;
//# sourceMappingURL=createIntOptions.js.map